import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { smsLogsQueries } from '@/services/smsLogs/smsLogs.queries';
import { useSearch } from '@tanstack/react-router';

export const useSmsLogsList = () => {
  const { createdDate, page, fetch, q, sort } = useSearch({ from: '/(app)/logs-management/sms-logs/' });
  const parsedCreatedDate = parseDateRangeSearch(createdDate);

  const { data, isLoading } = useQuery({
    ...smsLogsQueries.list({
      fromDate: parsedCreatedDate.start,
      toDate: parsedCreatedDate.end,
      row: page,
      fetch: fetch,
      search: q,
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data ?? [], sort),
    }),
  });

  return {
    smsLogs: data?.data || [],
    isLoading,
    pagination: data?.meta?.pagination || defaultMeta,
  };
};
